var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentSettingsCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 35,
    viewBox: "0 0 55 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 35,
    rx: 4,
    fill: "#E3DBFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43.5,
    y: 2.5,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#B7AAE2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 23.5,
    width: 20,
    height: 9,
    rx: 2,
    fill: "#B7AAE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSettingsCard);
export default __webpack_public_path__ + "static/media/payment-settings-card.06698969eef73ca78153cd2c5c7e147b.svg";
export { ForwardRef as ReactComponent };